/**
 * 从响应头中解析文件名
 * @param {string} contentDisposition - Content-Disposition 响应头
 * @returns {string} 解析出的文件名
 */
function getFileNameFromContentDisposition(contentDisposition) {
  if (!contentDisposition) {
    return null
  }
  
  // 处理 filename*=UTF-8'' 格式（RFC 5987）
  const utf8FileNameMatch = contentDisposition.match(/filename\*=UTF-8''(.+)/i)
  if (utf8FileNameMatch) {
    return decodeURIComponent(utf8FileNameMatch[1])
  }
  
  // 处理标准的 filename="xxx" 格式
  const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/i)
  if (fileNameMatch) {
    // 移除可能的引号并处理编码
    return fileNameMatch[1].replace(/['"]/g, '')
  }
  
  return null
}

export function downloadBlob(responseOrBlob, fileName) {
  // 兼容两种入参：
  // 1) 直接传入 Blob
  // 2) 传入 Axios Response（responseType: 'blob'）
  let blob = null
  let finalFileName = fileName || 'download.xlsx'

  const maybeResponse = responseOrBlob
  const isAxiosResponse = !!(maybeResponse && maybeResponse.data && maybeResponse.headers)

  if (isAxiosResponse) {
    // 从响应中拿到 blob 与文件名
    const res = maybeResponse
    const contentDisposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
    const parsedName = getFileNameFromContentDisposition(contentDisposition)
    if (parsedName) finalFileName = parsedName
    blob = res.data instanceof Blob ? res.data : new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' })
  } else if (responseOrBlob instanceof Blob) {
    blob = responseOrBlob
  } else {
    // 回退处理为普通数据（历史调用传了对象/字符串会导致 [object Object]）
    const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    blob = new Blob([responseOrBlob], { type: mimeType })
  }

  const downloadElement = document.createElement('a')
  const href = window.URL.createObjectURL(blob)
  downloadElement.href = href
  downloadElement.download = finalFileName
  document.body.appendChild(downloadElement)
  downloadElement.click()
  document.body.removeChild(downloadElement)
  window.URL.revokeObjectURL(href)
}

// 导出文件名解析函数供外部使用
export { getFileNameFromContentDisposition }
